interface ProductHeaderProps {
  name: string;
  price: number;
  adjustedPrice?: number;
  showDiscountedPrice: boolean;
}

export const ProductHeader = ({ name, price, adjustedPrice, showDiscountedPrice }: ProductHeaderProps) => (
  <>
    <h1 className="text-3xl font-extrabold tracking-tight text-gray-900">
      {name}
    </h1>
    <div className="mt-3">
      <h2 className="sr-only">Product information</h2>
      <div className="flex">
        <p className={`text-3xl text-gray-900 ${showDiscountedPrice ? 'line-through' : ''}`}>
          ${price}
        </p>
        {showDiscountedPrice && (
          <p className="text-3xl italic text-gray-900 ml-3">
            ${adjustedPrice}
          </p>
        )}
      </div>
    </div>
  </>
);
